export default __webpack_public_path__ + "media/images/select2-old-aef13653d8e0959bdf34bb739c7feec0.png";